var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullAccess = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 241,
    viewBox: "0 0 600 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1968_40611)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1968_40611)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 520,
    height: 187,
    rx: 8,
    fill: "#FCF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.972 149.397L298.726 143.845L321.867 136.8L321.795 148.811L298.972 149.397Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.729 130.975L301.517 131.248",
    stroke: "black",
    strokeWidth: 0.65822
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.992 156.914C299.992 156.914 299.761 151.616 300.872 150.949C301.984 150.282 318.363 147.855 321.401 147.707C324.439 147.633 323.632 157.197 323.632 157.197C323.632 157.197 331.326 157.864 340.518 159.469C346.741 160.061 377.149 227.624 377.149 227.624L345.111 228.225L272.132 228.002L277.244 194.365C277.244 194.365 210.933 177.176 204.043 110.124C218.713 105.234 227.9 102.419 227.9 102.419C227.9 102.419 239.163 152.542 299.992 156.914Z",
    fill: "#E473FF",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.953 147.095C298.953 147.095 299.842 151.244 299.62 155.689L298.953 147.095Z",
    fill: "#E473FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.953 147.095C298.953 147.095 299.842 151.244 299.62 155.689",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.473 147.095C305.473 147.095 304.807 155.022 306.14 156.06L305.473 147.095Z",
    fill: "#E473FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.473 147.095C305.473 147.095 304.807 155.022 306.14 156.06",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.475 147.762L312.141 156.727",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.031 147.613C319.031 147.613 317.475 153.466 319.031 155.319V147.613Z",
    fill: "#E473FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.031 147.613C319.031 147.613 317.475 153.466 319.031 155.319",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.406 200.589L347.779 222.742",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.924 209.851C333.924 209.851 342.296 217.556 350.446 225.039L333.924 209.851Z",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.924 209.851C333.924 209.851 342.296 217.556 350.446 225.039",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.665 210.443C334.665 210.443 323.403 198.663 318.365 198.663C313.401 198.663 292.73 199.108 292.582 201.404C292.433 203.627 294.508 204.59 297.546 204.59C300.583 204.59 314.068 202.368 314.068 202.368C314.068 202.368 296.138 211.777 297.323 214.963C298.509 218.149 316.809 205.554 316.809 205.554C316.809 205.554 302.065 218.149 303.992 219.705C305.918 221.261 319.106 208.517 319.106 208.517C319.106 208.517 309.845 218.593 310.438 220.964C311.03 223.335 320.143 212.148 320.143 212.148L323.255 222.372L334.665 210.443Z",
    fill: "#9C768C",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.508 226.421L193.227 177.324H250.128L269.032 226.368L211.508 226.421Z",
    fill: "#FEF8FF",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.387 177.25L250.127 177.324L269.031 226.421H317.464L317.031 223.26H271.761L253.387 177.25Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.264 136.966L293.191 139.818C292.726 140.248 292.699 140.974 293.13 141.438L295.982 144.511C296.412 144.976 297.138 145.003 297.602 144.572L300.675 141.72C301.14 141.289 301.167 140.564 300.736 140.1L297.884 137.026C297.454 136.562 296.728 136.535 296.264 136.966Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.942 145.559L294.058 147.308C293.593 147.738 293.566 148.464 293.997 148.928L295.746 150.813C296.177 151.277 296.902 151.304 297.366 150.873L299.251 149.124C299.715 148.694 299.742 147.968 299.312 147.504L297.563 145.619C297.132 145.155 296.407 145.128 295.942 145.559Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.013 144.017C314.013 144.017 311.206 148.676 307.2 151.4C306.093 152.158 304.816 152.755 303.526 152.855C297.642 153.472 292.055 150.238 291.607 144.515C290.094 125.927 294.032 116.299 294.032 116.299L305.138 110.043L317.271 132.961C317.271 132.961 320.109 127.418 323.831 131.563C327.587 135.774 321.816 139.438 319.528 138.139",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.013 144.017C314.013 144.017 311.206 148.676 307.2 151.4C306.093 152.158 304.816 152.755 303.526 152.855C297.642 153.472 292.055 150.238 291.607 144.515C290.094 125.927 294.032 116.299 294.032 116.299L305.138 110.043L317.271 132.961C317.271 132.961 320.109 127.418 323.831 131.563C327.587 135.774 321.816 139.438 319.528 138.139",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.592 122.104C292.592 122.104 299.631 120.031 301.973 114.501C303.157 121.762 311.65 129.66 316.857 133.601C319.935 129.61 321.129 128.385 324.201 131.785C324.124 125.026 325.559 117.795 324.583 115.965C323.607 114.134 315.759 108.075 310.743 107.642C305.029 107.162 299.193 108.342 296.068 111.771C292.977 115.266 292.592 122.104 292.592 122.104Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.78 106.308C309.78 106.308 301.231 96.2568 303.629 89.1009C305.992 81.8797 315.104 69.0463 325.681 69.2008C336.258 69.3552 345.84 80.8716 347.112 85.1472C348.384 89.4229 350.448 101.169 343.077 107.029C335.706 112.89 327.586 115.455 321.829 112.059C315.972 108.633 309.78 106.308 309.78 106.308Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.334 110.288C336.334 110.288 360.053 104.697 347.056 86.7731",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.726 100.803C346.726 100.803 360.676 84.1309 338.18 74.3774",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.595 89.0358C303.595 89.0358 304.148 68.3385 324.583 69.0308",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.14 76.9751C316.14 76.9751 298.601 83.1344 300.686 95.7084C302.671 108.252 317.803 107.658 317.803 107.658",
    stroke: "#040222",
    strokeWidth: 1.3118,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.235 136.54C289.94 136.029 286.624 132.172 289.235 128.093C291.882 124.079 298.349 124.242 299.551 129.646C300.527 133.996 295.431 136.88 293.235 136.54Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.208 136.206C302.208 136.206 299.899 131.559 303.272 128.753C306.646 125.947 310.786 127.099 312.851 131.287C314.916 135.476 309.882 139.419 306.487 138.878C303.027 138.372 302.208 136.206 302.208 136.206Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.056 134.787C293.056 134.787 292.124 129.574 294.552 127.357C295.585 131.34 293.056 134.787 293.056 134.787Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.931 136.572C305.931 136.572 304.999 131.36 307.427 129.142C308.46 133.125 305.931 136.572 305.931 136.572Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.307 137.051C300.307 137.051 296.794 139.595 297.718 136.919C298.643 134.244 299.916 130.962 299.916 130.962",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.307 137.051C300.307 137.051 296.794 139.595 297.718 136.919C298.643 134.244 299.916 130.962 299.916 130.962",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.002 140.128C298.002 140.128 297.125 143.366 299.03 143.946C299.932 144.22 300.808 140.982 300.808 140.982",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.002 140.128C298.002 140.128 297.125 143.366 299.03 143.946C299.932 144.22 300.808 140.982 300.808 140.982",
    stroke: "#040222",
    strokeWidth: 0.655899,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.279 86.4143C206.279 86.4143 218.23 88.8664 217.934 90.7755C217.639 92.6847 206.196 89.8602 206.196 89.8602C206.196 89.8602 218.125 92.4592 217.908 94.8316C217.713 97.0572 205.311 93.633 205.311 93.633C205.311 93.633 218.268 96.3911 216.876 98.5816C215.484 100.772 205.68 98.051 205.68 98.051C205.68 98.051 215.62 99.891 215.166 102.828C215.007 103.856 212.543 104.227 209.561 104.065C204.522 103.586 197.609 101.613 196.11 98.6744C193.809 94.1076 201.524 95.7534 201.524 95.7534C201.524 95.7534 201.524 95.7534 198.262 92.5415C195 89.3296 200.154 87.1201 200.154 87.1201C200.154 87.1201 193.03 81.6562 199.798 81.6515C206.713 81.6695 215.983 86.8644 217.657 85.7701C219.33 84.6758 218.433 80.1461 218.274 78.5052C218.115 76.8642 217.789 72.9062 222.082 72.3681C224.207 72.3681 222.367 76.0672 223.314 80.1929C224.15 85.2106 223.659 87.005 223.322 89.6374C222.751 95.2633 224.154 103.746 224.154 103.746L208.07 108.792L207.591 104.122",
    fill: "#9C768C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.279 86.4143C206.279 86.4143 218.23 88.8664 217.934 90.7755C217.639 92.6847 206.196 89.8602 206.196 89.8602C206.196 89.8602 218.125 92.4592 217.908 94.8316C217.713 97.0572 205.311 93.633 205.311 93.633C205.311 93.633 218.268 96.3911 216.876 98.5816C215.484 100.772 205.68 98.051 205.68 98.051C205.68 98.051 215.62 99.891 215.166 102.828C215.007 103.856 212.543 104.227 209.561 104.065C204.522 103.586 197.609 101.613 196.11 98.6744C193.809 94.1076 201.524 95.7534 201.524 95.7534C201.524 95.7534 201.524 95.7534 198.262 92.5415C195 89.3296 200.154 87.1201 200.154 87.1201C200.154 87.1201 193.03 81.6562 199.798 81.6515C206.713 81.6695 215.983 86.8644 217.657 85.7701C219.33 84.6758 218.433 80.1461 218.274 78.5052C218.115 76.8642 217.789 72.9062 222.082 72.3681C224.207 72.3681 222.367 76.0672 223.314 80.1929C224.15 85.2106 223.659 87.005 223.322 89.6374C222.751 95.2633 224.154 103.746 224.154 103.746L208.07 108.792L207.591 104.122",
    stroke: "#040222",
    strokeWidth: 1.3086,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.795 137.727L316.955 140.568C316.526 140.997 316.526 141.692 316.955 142.121L319.795 144.962C320.224 145.391 320.92 145.391 321.349 144.962L324.19 142.121C324.619 141.692 324.619 140.997 324.19 140.568L321.349 137.727C320.92 137.298 320.224 137.298 319.795 137.727Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.25697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.796 145.966L318.054 147.708C317.625 148.137 317.625 148.833 318.054 149.262L319.796 151.004C320.225 151.433 320.921 151.433 321.35 151.004L323.092 149.262C323.521 148.833 323.521 148.137 323.092 147.708L321.35 145.966C320.921 145.537 320.225 145.537 319.796 145.966Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.25697,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1968_40611",
    x: 39,
    y: 40,
    width: 522,
    height: 189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0156863 0 0 0 0 0.00784314 0 0 0 0 0.133333 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1968_40611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1968_40611",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1968_40611"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 520,
    height: 187,
    rx: 8,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullAccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fullAccess.791e8a6cb95d3bd2cb6cb4e1ae7fb476.svg";